import React, { useCallback } from 'react';

import { LockboxCheck } from '@/modules/employer/components/Lockbox/lockbox.types';
import ReissuePaymentModal from '@/modules/employer/components/ReconciliationReports/ReissuePaymentModal/ReissuePaymentModal';

interface Props {
  isVisible: boolean;
  check?: LockboxCheck;
  setIsVisible: (value: boolean) => void;
  onUpdateLockbox: () => Promise<void>;
}

const ReissueReturnedLockboxCheckModal: React.FC<Props> = ({
  isVisible,
  setIsVisible,
  onUpdateLockbox,
  check,
}) => {
  const handleClose = useCallback(() => {
    setIsVisible(false);
  }, [setIsVisible]);

  const handleSubmit = useCallback(() => onUpdateLockbox(), [onUpdateLockbox]);

  return (
    <ReissuePaymentModal
      isVisible={isVisible}
      check={check}
      onClose={handleClose}
      onSubmit={handleSubmit}
      onSuccessClose={handleClose}
    />
  );
};

export default ReissueReturnedLockboxCheckModal;
